import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/design-tokens.css';
import '@cloudsam/ui/dist/styles.css'; // shared shell + components; must follow the tokens
import './styles/app-base.css';
import './styles/channels.css';
import './hanko-init'; // must be imported before any auth-aware component
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import IdleSessionGate from './components/IdleSessionGate';
import { REQUIRE_AUTH } from './config';

// Surface identity: the tint is declared once on the app root and inherited by
// every panel through --color-surface-*. It is set on #root rather than on a
// wrapper inside React, so an overlay that mounts into #root inherits it too.
const rootEl = document.getElementById('root');
rootEl.classList.add('app--channels');

// The sign-in gate is skipped when sign-in is not required, which is the local
// default. See src/config.js: a page served from localhost cannot hold a cookie
// scoped to samsurveyor.com, so demanding one there locks the screen shut on the
// machine where it is being built.
const root = ReactDOM.createRoot(rootEl);
root.render(
    <React.StrictMode>
        <AuthProvider>
            {/* The idle gate sits inside ProtectedRoute, so it only ever runs
                for somebody who is signed in. With sign-in off there is no
                session to end, so the gate is left out entirely. */}
            {REQUIRE_AUTH
                ? <ProtectedRoute><IdleSessionGate><App /></IdleSessionGate></ProtectedRoute>
                : <App />}
        </AuthProvider>
    </React.StrictMode>
);
